import { render, staticRenderFns } from "./planningWrapper.vue?vue&type=template&id=6c241530"
import script from "./planningWrapper.vue?vue&type=script&lang=js"
export * from "./planningWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports